import type { LngLatBounds } from 'maplibre-gl';

export function areBoundsEqual(bounds1?: LngLatBounds, bounds2?: LngLatBounds): boolean {
	if (!bounds1 && !bounds2) {
		return true;
	}

	if (!bounds1 || !bounds2) {
		return false;
	}

	// Check if the bounds are equal with a 1 meter tolerance
	// This is necessary because the bounds are not always exactly the same and their precision
	// can vary depending on the zoom level and the map's size
	const areNorthEastEquals = bounds1.getNorthEast().distanceTo(bounds2.getNorthEast()) < 1;
	const areNorthWestEquals = bounds1.getNorthWest().distanceTo(bounds2.getNorthWest()) < 1;
	const areSouthEastEquals = bounds1.getSouthEast().distanceTo(bounds2.getSouthEast()) < 1;
	const areSouthWestEquals = bounds1.getSouthWest().distanceTo(bounds2.getSouthWest()) < 1;

	return areNorthEastEquals && areNorthWestEquals && areSouthEastEquals && areSouthWestEquals;
}
